<template>
	<div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"
					   rowKey="id" :pagination="false" :scroll="{y:500}">
		</a-table>
	</div>
</template>

<script>
	const  columns=[
		{
			title: '扫描任务ID',
			dataIndex: 'scanningtaskid',
		},
		{
		    title: '扫描时间',
		   dataIndex:'scanningdate',
		},
		{
		    title: '欠费用户总数',
		   dataIndex:'arrearsnum',
		},
		{
		    title: '短信发送数',
		   dataIndex:'smsnum',
		},
	];
	export default{
		props:['theObj'],
		data(){
			return{
				columns,
				list:[],
				loading:true,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_RECORD_LIST_URL);
				let param = {taskId:this.theObj.id};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
